// Default production server is "partykit.juaoose.partykit.dev", for local dev use "localhost:1999"
export const PARTYKIT_SERVER = "partykit.juaoose.partykit.dev";
